import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from '@core/app-constants';
import { FarmDevice, FarmDevicePairingResult } from '@shared/model/farm-device.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class FarmDeviceService {
	constructor(private http: HttpClient) {}

	/**
	 * User-scoped: every device across the farms the authenticated user belongs to.
	 * `FarmDeviceResource::collection()` wraps in a `data` envelope — `$wrap = false` on
	 * the resource only suppresses wrapping for a single resource, not `::collection()`.
	 */
	public list(): Observable<FarmDevice[]> {
		return this.http
			.get<{ data: FarmDevice[] }>(`${AppConstants.apiUrl}/devices`)
			.pipe(map((response) => response.data));
	}

	public create(farmId: string, name?: string): Observable<FarmDevicePairingResult> {
		return this.http.post<FarmDevicePairingResult>(`${AppConstants.apiUrl}/farms/${farmId}/devices`, { name });
	}

	public reissuePairingCode(deviceId: string): Observable<FarmDevicePairingResult> {
		return this.http.post<FarmDevicePairingResult>(`${AppConstants.apiUrl}/devices/${deviceId}/pairing-code`, {});
	}

	public getPairingCode(deviceId: string): Observable<FarmDevicePairingResult> {
		return this.http.get<FarmDevicePairingResult>(`${AppConstants.apiUrl}/devices/${deviceId}/pairing-code`);
	}

	public disconnect(deviceId: string): Observable<FarmDevice> {
		return this.http.post<FarmDevice>(`${AppConstants.apiUrl}/devices/${deviceId}/disconnect`, {});
	}

	public delete(deviceId: string): Observable<void> {
		return this.http.delete<void>(`${AppConstants.apiUrl}/devices/${deviceId}`);
	}
}
